import { render, staticRenderFns } from "./printHKPurReturn.vue?vue&type=template&id=08a5bdc3&scoped=true&"
import script from "./printHKPurReturn.vue?vue&type=script&lang=js&"
export * from "./printHKPurReturn.vue?vue&type=script&lang=js&"
import style0 from "./printHKPurReturn.vue?vue&type=style&index=0&id=08a5bdc3&lang=less&scoped=true&media=print&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a5bdc3",
  null
  
)

component.options.__file = "printHKPurReturn.vue"
export default component.exports